import { createApi } from '@reduxjs/toolkit/query/react';

import { clientApi2 } from '@app/api/Client';

import { createApiBaseQuery, Methods } from '../shared';

import { AI_SERVICES_CHUNK } from './const';
import {
  AiServicesEndpoints as Endpoints,
  type GetAiServicesRequest,
  type GetAiServicesResponse,
  type EnableAiServiceRequest,
  type EnableAiServiceResponse,
} from './types';

const AI_SERVICES_TAG = 'AiServices';

export const aiServicesApi = createApi({
  reducerPath: 'aiServicesApi',
  baseQuery: createApiBaseQuery(AI_SERVICES_CHUNK),
  tagTypes: [AI_SERVICES_TAG],
  endpoints: ({ query, mutation }) => ({
    [Endpoints.Get]: query<GetAiServicesResponse, GetAiServicesRequest>({
      query: (params) => ({
        url: Endpoints.Get,
        method: Methods.GET,
        params,
      }),
      providesTags: [AI_SERVICES_TAG],
    }),
    [Endpoints.Enable]: mutation<
      EnableAiServiceResponse,
      EnableAiServiceRequest
    >({
      query: ({ Key, IsOn, ...params }) => ({
        url: Endpoints.Enable,
        method: Methods.PATCH,
        params: { ...params, key: Key, isOn: IsOn },
      }),
      invalidatesTags: [AI_SERVICES_TAG],
      // Карточка лида отдаёт IsAiAutoReply из этих же настроек, но живёт в
      // другом api-слайсе — тег AiServices её не затрагивает. Без сброса
      // кнопка «Подготовить ответ с помощью ИИ» появлялась/исчезала только
      // после очистки кэша RTK Query (перезагрузка страницы).
      onQueryStarted: async (_arg, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(clientApi2.util.invalidateTags(['LeadCard']));
        } catch {
          // Настройка не сохранилась — сбрасывать карточку незачем.
        }
      },
    }),
  }),
});

export const { useGetAiServicesQuery, useEnableAiServiceMutation } =
  aiServicesApi;
